<template>
  <div class="head">
    <div class="head-center">
      <div class="logo">
        <a href="https://www.quandashi.com/" class="link-logo">
          <img src="/static/images/logo.png" alt="权大师">
        </a>
      </div>
      <!-- <div class="title">商标公告</div> -->
      <div class="search-input">
        <i class="icon-search"></i>
        <el-input v-model="brandInput" placeholder="请输入商标名称"></el-input>
        <!-- <i class="icon-camera"></i> -->
        <span class="quan-search" @click="search">权一下</span>
      </div>
      <div class="btn-wrapper">
        <button @click="goodsCategory">商品分类</button>
        <!-- <button @click="firstNotice">初审公告</button> -->
        <button @click="brandNotice">商标公告</button>
      </div>
      <div class="login" v-if="flag && info">
        <el-popover
          popper-class="head-popover"
          placement="bottom-end"
          width="200"
          trigger="hover"
          >
          <div class="head-menu">
            <!-- <div><a class="icon-grzx" :href="urlPrefix + 'home/index'">个人中心</a></div>
            <div><a class="icon-pt" :href="urlPrefix + 'partner-center/index'">切换为合伙人</a></div>
            <div class="lines"></div> -->
            <div><a class="icon-grxx" :href="urlPrefix + 'personal-setting'">个人信息</a></div>
            <div><a class="icon-zhaq" :href="urlPrefix + '/personal-setting/account-security'">账户安全</a></div>
            <div class="lines"></div>
            <div><a class="icon-tcdl" @click="logout">退出登录</a></div>
          </div>
          <button slot="reference" style="display: flex;align-items: center;">
            <el-avatar v-if="!info.avtar" :size="24" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
            <el-avatar v-else :size="24" :src="info.avtar.indexOf('http') > -1 ? info.avtar : filesPrefix + info.avtar"></el-avatar>
            <span class="userName">{{info.userName}}</span>
          </button>
        </el-popover>
      </div>
      <div v-else class="lg">
        <a :href="loginUrl">登录</a>
      </div>
    </div>
  </div>
</template>

<script>
import {Common} from '@/common'
export default {
  data () {
    return {
      filesPrefix: 'https://tm-files.oss-cn-beijing.aliyuncs.com/',
      urlPrefix: 'https://www.quandashi.com/',
      loginUrl: '',
      brandInput: '',
      flag: false,
      info: null
    }
  },
  created () {
    this.flag = Common.getCookie('QDS_COOKIE')
    let info_data = Common.getCookie('QDS_LOGIN_INFO')
    // let info_data = '%7B%22userName%22%3A%22%5Cu6d4bXX%22%2C%22avtar%22%3A%22third%5C%2F2019%5C%2F01%5C%2F08%5C%2F25582c720a49148de217a266a9ada1e9.jpg%22%7D'
    // let info_data = '%7B%22userName%22%3A%22qds7932313%22%2C%22avtar%22%3A%22%22%7D'
    this.info = info_data && JSON.parse(decodeURIComponent(info_data))
    console.log(this.info)
    this.loginUrl = `https://account.quandashi.com/?callback=${encodeURIComponent(`${this.api.soPrefix}`)}`
  },
  methods: {
    logout () {
      Common.delCookie('QDS_COOKIE')
      Common.delCookie('QDS_LOGIN_INFO')
      this.flag = false
      this.info = null
      setTimeout(function () {
          return (window.location.href = 'https://www.quandashi.com/index/logout')
      }, 1000)
    },
    goodsCategory () {
      let url = `${this.api.soPrefix}/index/nisi.html`
      window.open(url, 'goodsCategory')
    },
    firstNotice () {
      let url = `${this.api.soPrefix}/search/notice/index`
      window.open(url, 'firstNotice')
    },
    brandNotice () {
      let url = `${this.api.gonggaoPrefix}`
      window.open(url, 'brandNotice')
    },
    search () {
      let url = `${this.api.soPrefix}/index/search?key=${this.brandInput}`
      window.open(url, 'searchNotice')
    }
  }
}
</script>

<style lang="stylus" scoped>
.head
  height 60px
  background #FFFFFF
  box-shadow 0px 0px 6px 0px rgba(11, 17, 60, 0.1)
  .head-center
    width 80%
    height 100%
    padding-left 20%
    margin 0 auto
    display flex
    align-items center
    position relative
    .logo
      .link-logo
        display inline-block
        display flex 
        align-items center
        img
          width 130px
          margin-top 4px
    .title
      font-size 30px
      font-weight bold
      color #FF7200
      margin-left 32px
    .search-input
      width 480px
      margin 0 20px
      position relative
      >>>.el-input__inner
        height 36px
        line-height 36px
        padding 0 38px
        border 1px solid #ff7200
      .icon-search
        background url('/static/images/icon-search-i.png') no-repeat center
        display inline-block
        width 38px
        height 36px
        background-size 14px
        position absolute
        z-index 1
      .icon-camera
        background url('/static/images/pic-search.png') no-repeat center
        display inline-block
        width 26px
        height 26px
        position absolute
        top 5px
        right 125px
        z-index 1
        background-size contain
      .quan-search
        width 120px
        height 36px
        line-height 36px
        color #ffffff
        background #FF7200
        font-size 14px
        text-align center
        position absolute
        right 0
        border-radius 0 2px 2px 0
        cursor pointer
    .btn-wrapper
      button
        height 30px
        border 1px solid #FF7200
        color #FF7200
        margin-right 12px
        box-sizing border-box
        vertical-align middle
.login
  background url('/static/images/head/icon-more-arrow.png') no-repeat right bottom
  background-size 6px
  position absolute
  right 0
  button
    color #333
    font-size 16px
    img
      width 28px
      height 28px
      border-radius 50%
      vertical-align middle
      margin-right 4px
    .userName
      font-size 14px
      max-width 100px
      display inline-block
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      padding 0 5px
      vertical-align middle
.head-popover
  .head-menu
    width 200px
    background #FFFFFF
    box-shadow 0px 0px 6px 0px rgba(11, 17, 60, 0.1)
    border-radius 2px
    margin-top 0px
    font-size 13px
    cursor pointer
    div
      line-height 42px
      font-size 13px
      text-align left
      a
        display inline-block
        width 100%
        padding-left 60px
        text-decoration none
        color #333
        font-size 12px
      .icon-grzx
        background url('/static/images/head/icon-grzx.png') no-repeat 20px center
        background-size 16px auto
      .icon-pt
        background url('/static/images/head/icon-pt.png') no-repeat 20px center
        background-size 16px auto
      .icon-grxx
        background url('/static/images/head/icon-grxx.png') no-repeat 20px center
        background-size 16px auto
      .icon-zhaq
        background url('/static/images/head/icon-zhaq.png') no-repeat 20px center
        background-size 16px auto
      .icon-tcdl
        background url('/static/images/head/icon-tcdl.png') no-repeat 20px center
        background-size 16px auto
    .lines
      width 200px
      height 4px
      background #F7F7F8
.lg
  position absolute
  right 0
  a
    color #666666
    text-decoration none
</style>



// WEBPACK FOOTER //
// src/components/Head.vue